import {
  Checkbox,
  FormControlLabel,
  InputLabel,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@material-ui/core";
import { DatePicker } from "@material-ui/pickers";
import { makeStyles, withStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import { format } from "date-fns";
import { useFormik } from "formik";
import { cancelServiceId } from "libs/configs/constant";
import { CANCEL_STEP } from "libs/constant/VisaStep";
import useModalLoading from "libs/hooks/useModalLoading";
import { get } from "lodash-es";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import {
  addSmartFromCancel,
  getPartFormDetail,
  setStep
} from "redux/modules/cancelVisaSlice";
import { selectMasterData } from "redux/modules/masterSlice";
import { readOCRPassport } from "redux/modules/passportSlice";
import { addPersonalStatusReport } from "redux/modules/statusReportSlice";
import * as yup from "yup";

const useStyles = makeStyles((theme) => ({
  paper: {
    // display: "flex",
    // flexDirection: "column",
    // flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
  },
  wrapTitleContent: {
    width: 36,
    display: "flex",
    justifyContent: "center",
    marginRight: 3,
    marginLeft: 8,
  },
  badge: {
    display: "flex",
    width: 25,
    height: 25,
    borderRadius: 25,
    backgroundColor: "#feb969",
    marginRight: 8,
    textAlign: "center",
    color: "#fff",
    justifyContent: "center",
    alignItems: "center",
  },
  tableTitle: {
    color: "#8898aa",
    marginLeft: 16,
  },
  table: {
    minWidth: 700,
    "& .MuiTableCell-root": {
      borderLeft: "1px solid rgba(224, 224, 224, 1)",
      borderRight: "1px solid rgba(224, 224, 224, 1)",
    },
  },
  cellContent: {
    display: "flex",
  },
  cellContentWithRowSpan: {
    display: "flex",
    flex: 1,
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  formControl: {
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    minWidth: 120,
    // width: 300,
  },
  wrapField: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  cellContentList: {
    paddingLeft: "45px",
    display: "flex",
    alignItems: "center",
  },
  textField: {
    display: "flex",
    flex: 1,
    cursor: "pointer",
    marginTop: 8,
  },
  wrapError: {
    textAlign: "right",
    fontSize: "0.8rem",
    color: "orangered",
    paddingRight: "10px",
  },
  middle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  linka: {
    textDecoration: "underline",
    cursor: "pointer",
    color: "mediumblue",
    paddingLeft: "15px",
  },
  closeButton: {
    color: "red",
    fontSize: "16px",
    paddingLeft: "10px",
    paddingTop: "5px",
    cursor: "pointer",
  },
}));

const StyleCheckbox = withStyles((theme) => ({
  root: {
    borderRadius: 6,
    color: "#8898aa",
    "&$checked": {
      color: theme.palette.success.main,
    },
  },
  checked: {},
}))(Checkbox);

const Bagde = ({ number }) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapTitleContent}>
      {!!number && <div className={classes.badge}>{number}</div>}
    </div>
  );
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
    fontSize: 16,
  },
  body: {
    fontSize: 16,
  },
}))(TableCell);

const TableRowHead = withStyles((theme) => ({
  root: {
    backgroundColor: "#f1f3f9",
    color: "#172b4d",
  },
}))(TableRow);

function UploadButton({ id, onChange, title, disabled }) {
  const classes = useStyles();
  return (
    <div>
      <input
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        disabled={disabled}
        onChange={onChange}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          component="span"
          fullWidth={false}
          disabled={disabled}
          style={{ height: 40, width: 200 }}
          variant="outlined"
          color="primary"
          type="button"
        >
          {title || "BROWSE"}
        </ColorButton>
      </label>
    </div>
  );
}

export default function CancelPartA() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { smartDetail, partForm, oldData } = useSelector(
    (state) => state.cancelVisa
  );
  const personalDetail = useSelector((state) => state.personal.detail);

  const masterData = useSelector(selectMasterData);
  const smartservice = get(masterData, "smartservice", []);
  const { showLoading, hideLoading } = useModalLoading();
  const [passportFile, setPassportFile] = useState(null);
  const passportState = useSelector((state) => state.passport);
  const visaValidaDate = new Date(smartDetail?.visaValidDate);
  const now = new Date();
  const today = new Date();
  today.setDate(today.getDate() + 21);
  const maxDate =
    visaValidaDate > today
      ? today
      : visaValidaDate > now
      ? visaValidaDate
      : now;
  const [uploadPassportData, setUploadPassport] = useState(null);
  let { search } = useLocation();
  const query = new URLSearchParams(search);
  const draftId = query.get("draftId");

  const disableDesireDates = (date) => {
    if (maxDate && date) {
      return new Date(maxDate).getTime() < date.getTime();
    }
    return true;
  };
  const validationSchema = yup.object({
    // (!draftId) && { (termination: yup.date().required("Desired date is required.")) }
    // ...(!draftId && { termination: yup.date().required("Desired date is required.") }),
    // termination: yup.date().required("Desired date is required.")
  });

  const getItemDetail = (value, smartName) => {
    const control = partForm.defaultType.find(
      (x) => x.smartName.toLowerCase() === smartName.toLowerCase()
    );

    const body = {
      smartId: null,
      partfromId: control.partfromId,
      configsmartId: control.configsmartId,
      linkTable: control.linkTable,
      value: value,
    };

    return body;
  };

  const getItemsDetail = (values) => {
    const details = [];

    if (values.addressInHome) {
      const detail = getItemDetail(values.addressInHome, "addressInHome");
      details.push(detail);
    }
    if (values.phoneNumber) {
      const detail = getItemDetail(values.phoneNumber, "phoneNumber");
      details.push(detail);
    }
    if (values.email) {
      const detail = getItemDetail(values.email, "email");
      details.push(detail);
    }
    if (values.smart) {
      const detail = getItemDetail(values.smart, "smart");
      details.push(detail);
    }
    if (values.validUntil) {
      const date = format(new Date(values.validUntil), "yyyy-MM-dd");
      const detail = getItemDetail(date, "validUntil");
      details.push(detail);
    }
    if (values.termination) {
      const date = format(new Date(values.termination), "yyyy-MM-dd");
      const detail = getItemDetail(date, "termination");
      details.push(detail);
    }
    if (values.resignation) {
      const b = values.resignation ? 1 : 0;
      const detail = getItemDetail(b, "resignation");
      details.push(detail);
    }
    if (values.accompanying) {
      const b = values.accompanying ? 1 : 0;
      const detail = getItemDetail(b, "accompanying");
      details.push(detail);
    }
    if (values.change) {
      if (values.visatypeto) {
        const detail = getItemDetail(values.visatypeto, "visatypeto");
        details.push(detail);
      }

      const b = values.change ? 1 : 0;
      const detail2 = getItemDetail(b, "change");
      details.push(detail2);
    }

    if (values.failure) {
      const b = values.failure ? 1 : 0;
      const detail = getItemDetail(b, "failure");
      details.push(detail);
    }
    if (values.other) {
      if (values.specift) {
        const detail = getItemDetail(values.specift, "specift");
        details.push(detail);
      }
      const b = values.other ? 1 : 0;
      const detail2 = getItemDetail(b, "other");
      details.push(detail2);
    }

    return details;
  };

  const canDisplay = (controlName) => {
    if (partForm?.defaultType) {
      const allControls = partForm.defaultType.find(
        (x) => x.smartName.toLowerCase() === controlName.toLowerCase()
      );
      return allControls && allControls.isShow;
    }
    return false;
  };

  const handleUploadContractTerm = async (event) => {
    showLoading();
    setPassportFile(event.target.files[0]);
    dispatch(readOCRPassport(event.target.files[0]));
    event.target.value = null;
  };

  const getDataFromOld = (key) => {
    const dataFromOld = oldData?.detail?.find(
      (x) => x.smartName.toLowerCase() === key.toLowerCase()
    );
    if (dataFromOld) {
      if (key === "termination") {
        console.log(dataFromOld?.value);
        return format(new Date(dataFromOld?.value), "yyyy-MM-dd");
      } else {
        return dataFromOld?.value;
      }
    }
  };

  const dateDiffInDays = (a, b) => {
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  };

  const validDate = new Date(personalDetail?.validuntil);
  const dateDiff = dateDiffInDays(now, validDate);
  const desireDate =
    dateDiff > 21 || dateDiff <= 0
      ? now.setDate(now.getDate() + 21)
      : validDate;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      personal: {
        firstname:
          passportState?.detail?.firstName || personalDetail?.firstname,
        middleName: personalDetail?.middleName,
        lastName: passportState?.detail?.lastName || personalDetail?.lastName,
        passportNumber: personalDetail?.passportNumber,
        dateofIssue: personalDetail?.dateofIssue,
        validUntil: personalDetail?.validuntil,
        addressInHome: personalDetail?.addressInHome,
        phoneNumber: personalDetail?.mobile,
        email: personalDetail?.email,
        smart: smartDetail?.smartserviceId,
      },
      termination: !draftId
        ? format(desireDate, "yyyy-MM-dd")
        : getDataFromOld("termination"),
      resignation: !draftId ? "" : getDataFromOld("resignation"),
      accompanying: !draftId ? "" : getDataFromOld("accompanying"),
      change: !draftId ? "" : getDataFromOld("change"),
      visatypeto: !draftId ? "" : getDataFromOld("visatypeto"),
      failure: !draftId ? "" : getDataFromOld("failure"),
      other: !draftId ? "" : getDataFromOld("other"),
      specift: !draftId ? "" : getDataFromOld("specift"),
    },
    validationSchema,
    onSubmit: async (values) => {
      const details = getItemsDetail(values);
      const body = {
        draftId: null,
        smartserviceId: cancelServiceId,
        personalId: personalDetail.personalID,
        smartserviceReferId: smartDetail.smartserviceId,
        survey: null,
        visaissuance: null,
        fileDocument: [],
        detail: details,
      };

      const bodyPersonal = {
        personalID: personalDetail.personalID,
        fistName: formik.values.personal.firstname,
        middleName: formik.values.personal.middleName,
        lastName: formik.values.personal.lastName,
        email: formik.values.personal.email,
        passportNumber: formik.values.personal.passportNumber,
        dateofIssue: formik.values.personal.dateofIssue,
        validuntil: formik.values.personal.validUntil,

        visatypeID: personalDetail.visatypeID,
        placeOfBirth: personalDetail.placeOfBirth,
        nationalityID: personalDetail.nationalityID,
        birthDate: personalDetail.birthDate,
        gender: personalDetail.gender,
      };

      if (!draftId) {
        const resPersonal = dispatch(addPersonalStatusReport(bodyPersonal));
        const res = await dispatch(addSmartFromCancel(body));
        const newDraftId = res.payload;
        await dispatch(
          getPartFormDetail({
            personalId: personalDetail.personalID,
            draftId: newDraftId,
          })
        );
      } else {
        await dispatch(
          getPartFormDetail({
            personalId: personalDetail.personalID,
            draftId: draftId,
          })
        );
      }
      window.scrollTo(0, 0);
      dispatch(setStep(CANCEL_STEP.CANCEL_B));
    },
  });

  const isError = (fieldName) =>
    get(formik.touched, fieldName, "") &&
    Boolean(get(formik.errors, fieldName, ""));

  const getErrorMessage = (fieldName) =>
    get(formik.touched, fieldName, "")
      ? get(formik.errors, fieldName, "") || " "
      : " ";

  useEffect(() => {
    if (passportState) {
      if (passportState.isSuccess || passportState.isFailure) {
        hideLoading();
        setUploadPassport(passportFile);
      }
    }
  }, [passportState, hideLoading, passportFile]);

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <ContentTitle
          subTitle="Smart Visa Termination Request Form"
          title="Termination Request Form"
        />
        <form onSubmit={formik.handleSubmit} disabled>
          <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <div className={classes.middle}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Part A : Personal Information
                      </Typography>
                      <UploadButton
                        disabled={draftId ? true : false}
                        onChange={handleUploadContractTerm}
                        title="Update Passport"
                        id="cancel-upload-passport"
                      />
                    </div>
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableRow>
                <StyledTableCell colSpan={7}>
                  <div className={classes.cellContent}>
                    <Bagde number={1} />
                    <div>
                      <Typography>Full English name as in passport</Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
              <TableBody>
                <TableRow>
                  <StyledTableCell colSpan={3}>
                    <div className={classes.cellContent}>
                      <Bagde number={0} />
                      <div className={classes.wrapField}>
                        <InputLabel>First name</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.firstname"
                          value={formik.values.personal.firstname}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.firstname")}
                          helperText={getErrorMessage("personal.firstname")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Middle name</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.middleName"
                          value={formik.values.personal.middleName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.middleName")}
                          helperText={getErrorMessage("personal.middleName")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <div className={classes.wrapField}>
                        <InputLabel>Last name</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.lastName"
                          value={formik.values.personal.lastName}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.lastName")}
                          helperText={getErrorMessage("personal.lastName")}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell colSpan={3}>
                    <div className={classes.cellContent}>
                      <Bagde number={2} />
                      <div className={classes.wrapField}>
                        <InputLabel>Passport number</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.passportNumber"
                          value={formik.values.personal.passportNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.passportNumber", formik)}
                          helperText={getErrorMessage(
                            "personal.passportNumber",
                            formik
                          )}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={3} />
                      <div className={classes.wrapField}>
                        <InputLabel>Date of issue ( dd-mm-yyyy )</InputLabel>
                        <DatePicker
                          disabled={draftId}
                          className={classes.formControl}
                          inputVariant="outlined"
                          disableFuture={false}
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Date of issue"
                          views={["year", "month", "date"]}
                          name={`personal.dateofIssue`}
                          value={
                            get(formik.values, `personal.dateofIssue`, null) ||
                            null
                          }
                          onChange={(date) => {
                            formik.setFieldValue(
                              `personal.dateofIssue`,
                              date.format("YYYY-MM-DD")
                            );
                          }}
                          error={isError(`personal.dateofIssue`, formik)}
                          helperText={getErrorMessage(
                            `personal.dateofIssue`,
                            formik
                          )}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={4} />
                      <div className={classes.wrapField}>
                        <InputLabel>Valid until ( dd-mm-yyyy )</InputLabel>
                        <DatePicker
                          disabled={draftId}
                          className={classes.formControl}
                          inputVariant="outlined"
                          // disableFuture={false}
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Valid until"
                          views={["year", "month", "date"]}
                          name={`personal.validuntil`}
                          value={
                            get(formik.values, `personal.validuntil`, null) ||
                            null
                          }
                          onChange={(date) => {
                            formik.setFieldValue(
                              `personal.validuntil`,
                              date.format("YYYY-MM-DD")
                            );
                          }}
                          error={isError(`personal.validuntil`, formik)}
                          helperText={getErrorMessage(
                            `personal.validuntil`,
                            formik
                          )}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell colSpan={7}>
                    <div className={classes.cellContent}>
                      <Bagde number={5} />
                      <div className={classes.wrapField}>
                        <InputLabel>Home address</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.addressInHome"
                          value={formik.values.personal.addressInHome}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.addressInHome", formik)}
                          helperText={getErrorMessage(
                            "personal.addressInHome",
                            formik
                          )}
                          multiline
                          rows={5}
                          minRows={5}
                          maxRows={5}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>

                <TableRow>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={6} />
                      <div className={classes.wrapField}>
                        <InputLabel>Home/mobile phone number</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.phoneNumber"
                          inputProps={{ maxLength: 10 }}
                          onKeyDown={(e) => {
                            const pattern = /[^0-9]/g;
                            const isNotAllow =
                              e.key.length === 1 && pattern.test(e.key);

                            if (isNotAllow) {
                              e.preventDefault();
                            }
                          }}
                          value={formik.values.personal.phoneNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.phoneNumber", formik)}
                          helperText={getErrorMessage(
                            "personal.phoneNumber",
                            formik
                          )}
                          // type="tel"
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={7} />
                      <div className={classes.wrapField}>
                        <InputLabel>Email address</InputLabel>
                        <TextField
                          disabled={draftId}
                          variant="outlined"
                          className={classes.textField}
                          name="personal.email"
                          value={formik.values.personal.email}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.email", formik)}
                          helperText={getErrorMessage("personal.email", formik)}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell colSpan={2}>
                    <div className={classes.cellContent}>
                      <Bagde number={8} />

                      <div className={classes.wrapField}>
                        <InputLabel>Current Visa</InputLabel>
                        <TextField
                          variant="outlined"
                          disabled
                          className={classes.textField}
                          name="personal.smart"
                          value={
                            smartservice.find(
                              (x) =>
                                x.smartserviceId ===
                                formik.values.personal.smart
                            )?.smartserviceName
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          error={isError("personal.smart", formik)}
                          helperText={getErrorMessage("personal.smart", formik)}
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </TableRow>
              </TableBody>

              {/* partB */}
              {
                <TableBody>
                  <TableRowHead>
                    <StyledTableCell colSpan={7}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        Part B: Details of Smart Visa Termination
                      </Typography>
                    </StyledTableCell>
                  </TableRowHead>
                  <TableRow>
                    <StyledTableCell colSpan={7}>
                      {canDisplay("termination") && (
                        <div className={classes.cellContent}>
                          <div className={classes.flexRow}>
                            <Bagde number={1} />
                            <InputLabel>
                              Desired date of Smart Visa termination
                              (dd-mm-yyyy).
                            </InputLabel>
                            <div>
                              <DatePicker
                                disabled={draftId}
                                className={classes.formControl}
                                inputVariant="outlined"
                                openTo="year"
                                defaultValue={null}
                                format="DD-MM-YYYY"
                                label="Desired Date"
                                // disablePast={true}
                                views={["year", "month", "date"]}
                                name="termination"
                                value={formik.values.termination}
                                onChange={(date) => {
                                  formik.setFieldValue(
                                    `termination`,
                                    date.format("YYYY-MM-DD")
                                  );
                                }}
                                minDate={new Date()}
                                maxDate={desireDate}
                              />

                              <div className={classes.wrapError}>
                                {!draftId && formik.errors.termination ? (
                                  <div>{formik.errors.termination}</div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell colSpan={7}>
                      <div className={classes.cellContent}>
                        <Bagde number={2} />
                        <div className={classes.wrapField}>
                          <InputLabel>
                            Please describe reason(s) of Smart Visa Termination
                            (You can choose more than 1 reason).
                          </InputLabel>
                        </div>
                      </div>
                      {canDisplay("resignation") && (
                        <div className={classes.cellContentList}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={draftId}
                                name="resignation"
                                value={formik.values.resignation}
                                checked={Boolean(formik.values.resignation)}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "resignation",
                                    !formik.values.resignation
                                  );
                                }}
                              />
                            }
                            label="Resignation or termination of employment from the current Company."
                          />
                        </div>
                      )}
                      {canDisplay("accompanying") && (
                        <div className={classes.cellContentList}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={draftId}
                                name="accompanying"
                                value={formik.values.accompanying}
                                checked={Boolean(formik.values.accompanying)}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "accompanying",
                                    !formik.values.accompanying
                                  );
                                }}
                              />
                            }
                            label="Accompanying person of the main Smart Visa holder whose visa is terminated."
                          />
                        </div>
                      )}

                      <div className={classes.cellContentList}>
                        {canDisplay("change") && (
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={draftId}
                                name="change"
                                value={formik.values.change}
                                checked={Boolean(formik.values.change)}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "change",
                                    !formik.values.change
                                  );
                                }}
                              />
                            }
                            label="Change of visa type to"
                          />
                        )}
                        {canDisplay("visatypeto") && (
                          <TextField
                            variant="outlined"
                            className={classes.textField}
                            disabled={draftId}
                            id="visatypeto"
                            name="visatypeto"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.visatypeto}
                          />
                        )}
                      </div>
                      {canDisplay("failure") && (
                        <div className={classes.cellContentList}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                name="failure"
                                value={formik.values.failure}
                                disabled={draftId}
                                checked={Boolean(formik.values.failure)}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "failure",
                                    !formik.values.failure
                                  );
                                }}
                              />
                            }
                            label="Failure to meet Smart Visa qualifications."
                          />
                        </div>
                      )}
                      {canDisplay("other") && (
                        <div className={classes.cellContentList}>
                          <FormControlLabel
                            control={
                              <StyleCheckbox
                                disabled={draftId}
                                name="other"
                                value={formik.values.other}
                                checked={Boolean(formik.values.other)}
                                onClick={() => {
                                  formik.setFieldValue(
                                    "other",
                                    !formik.values.other
                                  );
                                }}
                              />
                            }
                            label="Others (Please specify) :"
                          />
                        </div>
                      )}
                      {canDisplay("specift") && (
                        <div className={classes.cellContentList}>
                          <TextField
                            variant="outlined"
                            disabled={draftId}
                            className={classes.textField}
                            multiline
                            rows={5}
                            id="specift"
                            name="specift"
                            type="text"
                            onChange={formik.handleChange}
                            value={formik.values.specift}
                          />
                        </div>
                      )}
                    </StyledTableCell>
                  </TableRow>
                </TableBody>
              }
            </Table>
          </TableContainer>
          <div
            style={{
              marginTop: 44,
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <ColorButton
              style={{ height: 40, width: 125, marginLeft: 20 }}
              variant="contained"
              color="primary"
              type="submit"
            >
              Next
            </ColorButton>
          </div>
        </form>
      </div>
    </Paper>
  );
}
